export default __webpack_public_path__ + "locales/bg/Files.json?hash=0d4f52c92d80b9fc006784d8e0ff182d";